const paymentDueReducer = (state = '', action) => {
	switch(action.type){
	case 'SETTEXT':	
		return action.payload;
	default:
		return state;
	}
}

export default paymentDueReducer;